import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'pdf-file-icon',
  templateUrl: './pdf-file-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class PdfFileIconComponent {}
